import { useState } from "react";
import { useParams, useSearchParams } from "react-router";

import type { CardProfileType } from "src/app/features/ApplicationProfile/subFeatures/CardProfile/types/CardProfileType";
import { PromptDataEditForm } from "src/app/features/ApplicationProfile/subFeatures/PromptData/components/forms/PromptDataEditForm";
import { ActionBar } from "../../../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../../../components/AppLayout/components/FPageLayout";
import { BackButton } from "../../../../../../components/FeatureButtons/BackButton";
import { SubmitButton } from "../../../../../../components/FeatureButtons/SubmitButton";
import { ResourceName } from "../../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../../core/router/types/routerTypes";

export const PromptDataEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);

    const { appProfileId, cardProfId } = useParams();

    const [searchParams] = useSearchParams();
    const type = searchParams.get("type") as CardProfileType;

    const backUrl = `${BASE_PATH}/${ResourceName.APPLICATION_PROFILE_LISTS}/${appProfileId}/${ResourceName.APPLICATION_PROFILE_CARD_DEFINITION_EFT4F}/${FORM_ACTION.EDIT}/${cardProfId}?type=${type}`;

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.promptDataEditFormPage" />
                <ActionBar>
                    <SubmitButton isDisabled={false} onClick={triggerFormSubmit} />
                    <BackButton isDisabled={false} url={backUrl} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <PromptDataEditForm runSubmit={runSubmit} />
            </FPageContent>
        </FPage>
    );
};
